export default __webpack_public_path__ + "static/equipo-carlos-Color-9d62b2fba60e11741286ed2d94eea878.png";